import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useActiveUser } from '../hooks/useActiveUser';
import { getMeta, setMeta } from '../services/db/meta';

/**
 * Top-of-app banner shown to anonymous users prompting sign-in for cloud
 * backup. Dismissable; dismissal is persisted in Dexie meta.
 */
export default function AnonymousBanner() {
  const navigate = useNavigate();
  const { isAnonymous, isLoading } = useActiveUser();
  // null = haven't read Dexie yet; render nothing rather than flash the
  // banner-then-hide-it (the previous default of `true` then async-flip-
  // to-false caused a visible jitter as the dismissal-state arrived).
  const [dismissed, setDismissed] = useState(null);

  useEffect(() => {
    getMeta('anonymousBannerDismissedAt').then((v) => setDismissed(!!v));
  }, []);

  if (isLoading || !isAnonymous || dismissed !== false) return null;

  const handleDismiss = async () => {
    setDismissed(true);
    try {
      await setMeta('anonymousBannerDismissedAt', new Date().toISOString());
    } catch {
      // best-effort; banner will reappear on next load if Dexie failed
    }
  };

  return (
    <div className="border-b border-amber-500/30 bg-amber-500/10 px-4 py-2 text-sm flex items-center gap-3">
      <span className="flex-1 text-amber-700 dark:text-amber-300">
        You're using PowderLog without an account. Sign in to back up your sessions.
      </span>
      <button
        type="button"
        onClick={() => navigate('/login')}
        className="rounded-md bg-amber-500 px-3 py-1 text-xs font-semibold text-black"
      >
        Sign in
      </button>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss"
        className="text-amber-700 dark:text-amber-300 px-2"
      >
        ×
      </button>
    </div>
  );
}
